import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Button, Grid, Paper, TablePagination } from "@material-ui/core";
import JobApprovalSearch from "./jobApprovalSearch";
import TableApproval from "./tableApproval";
import NotFile from './notFile';
import Scrollbars from "react-custom-scrollbars";
import { useForm } from 'react-hook-form';
import{ yupResolver} from "@hookform/resolvers/yup";
import * as yup from 'yup';
import { useStateValue } from "../../context/store";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: "sticky",
    width: 1100,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 5,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  scrollBars:{
    width: 900,
    height: 200,
    backgroundColor: "#ffffff",
    position: "sticky",
    padding: 0
  },
  paperdos:{
    width:'100%',
    height: 220,
    borderRadius: 5,
  },
}));

const ModalPermissions = ({
  headers,
  charge,
  regionals,
  open,
  dataId,
  handleClose,
  paginadorResponse,
  paginadorRequest,
  changePage,
  changeAmountOfRecords,
  setDataId,
  setOpen
}) => {
  const classes = useStyles();
  const [{}, dispatch] = useStateValue();

  const schema = yup.object().shape({
    firstName: yup.string(),
    lastName: yup.string(),
    chargeId: yup.string(),
    regionalId: yup.string(),
  })

  const {register, handleSubmit, control, formState: {errors}, setValue} = useForm({
      resolver: yupResolver(schema),
      mode: "onChange",
      reValidateMode: "onChange"
  });

  const clearBtn = () => {
      setValue("firstName", null);
      setValue("surname", null);
      setValue("chargeId", "");
      setValue("regionalId", "");
  }

  const clearForm = () => {
      clearBtn();
      dispatch({
        type: "SET_PERMISSIONS_FILTER",
        filter: {
          firstName : null,
          surname: null,
          chargeId : null,
          regionalId : null,
      },
      isFilter: true,
      });
  };

  const clearFilterPermissions = () => {
    clearForm();
    handleClose();
  }

  const body = (
    <div className={classes.paper}>
      <Grid container justifyContent="center" style={{marginBottom: 10}}>
        <h3 id="simple-modal-title">Usuario aprobador</h3>
      </Grid>
      <JobApprovalSearch
        charge={charge}
        regionals={regionals}
        handleSubmit={handleSubmit}
        register={register}
        errors={errors}
        clearForm={clearForm}
        control={control}
      />
      <Paper elevation={0} className={classes.paperdos}>
        <Scrollbars className={classes.Scrollbars}>
          {
            paginadorResponse.data?.map(resp => (
              <TableApproval
                headers={headers}
                data={resp}
                setDataId={setDataId}
                setOpen={setOpen}
                dataId={dataId}
                clearForm={clearForm}
                isModal={true}
              />
            ))
          }
          {paginadorResponse?.totalRows !== 0 ? (
            <TablePagination
              style={{ display: "flex", justifyContent: "center" }}
              rowsPerPageOptions={[5, 10, 15]}
              count={paginadorResponse?.totalRows}
              rowsPerPage={paginadorRequest?.size}
              page={paginadorRequest?.page}
              labelRowsPerPage="Registros por página"
              onChangePage={changePage}
              onChangeRowsPerPage={changeAmountOfRecords}
            />
          ) : (
            <React.Fragment>
              <NotFile/>
            </React.Fragment>
          )}
        </Scrollbars>
      </Paper>
      <Grid container justifyContent="center" style={{marginTop:20}}>
        <h3>Señor usuario recuerde que su permiso debe ser aprobado por su líder directo y también por el área de gestión humana.</h3>
      </Grid>
      <Grid container justifyContent="center" style={{marginTop:20}}>
        <Button
          variant="outlined"
          onClick={() => clearFilterPermissions()}
        >
          Cancelar
        </Button>
      </Grid>
    </div>
  );

  return (
    <div>
      <Modal
        open={open}
        //onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        {body}
      </Modal>
    </div>
  );
};
export default ModalPermissions;
